(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4646],{

/***/ 16027:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shops",
      function () {
        return __webpack_require__(63382);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 63382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_ui_MetaTag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42031);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83554);




var ShopsPage = function() {
    var shops = [
        {
            name: "Chi nh\xe1nh Hồ Ch\xed Minh",
            image: "/shop-hcm.jpg",
            address: "89A Nguyễn Tr\xe3i, Phường Bến Th\xe0nh, Quận 1, Tp.HCM, Việt Nam",
            map: "https://www.google.com/maps/place/An+Th%C6%B0+Jewellery/@10.7698821,106.6889064,17z/data=!4m15!1m8!3m7!1s0x31752f3da5f5bb57:0xd777e541a8968d18!2zODlBIMSQLiBOZ3V54buFbiBUcsOjaSwgUGjGsOG7nW5nIFBo4bqhbSBOZ8WpIEzDo28sIFF14bqtbiAxLCBUaMOgbmggcGjhu5EgSOG7kyBDaMOtIE1pbmgsIFZp4buHdCBOYW0!3b1!8m2!3d10.7698768!4d106.6914813!16s%2Fg%2F11j8h0h9cp!3m5!1s0x31752fd8ef5380a5:0x665b54ed78b96721!8m2!3d10.7698794!4d106.6914768!16s%2Fg%2F11g_vdk8nl?hl=vi-VN",
            phone_url: "0333336789",
            phone: "033 333 6789",
            time: "09:00 - 21:00"
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui_MetaTag__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: "Hệ thống chi nh\xe1nh An Thư",
                description: "Hệ thống chi nh\xe1nh An Thư"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "container tw-mx-auto md:tw-border-t tw-border-primary-main tw-pt-8 tw-pb-10 tw-text-secondary-70",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: "tw-text-[30px] tw-font-semibold tw-text-center",
                        children: "Hệ thống chi nh\xe1nh An Thư"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "tw-grid tw-gap-10 md:tw-gap-16 tw-mt-10",
                        children: shops.map(function(shop) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "md:tw-flex tw-gap-6 lg:tw-gap-10",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "tw-block md:tw-hidden tw-font-semibold",
                                        children: shop.name
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "tw-w-full tw-h-[250px] md:tw-w-[300px] md:tw-h-[200px] tw-rounded-5 tw-mt-2 lg:tw-mt-0 tw-bg-center tw-bg-cover",
                                        style: {
                                            backgroundImage: "url('".concat(shop.image, "')")
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "tw-w-full tw-flex tw-flex-col tw-gap-2 tw-flex-1 tw-mt-6 md:tw-mt-0",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                className: "tw-font-semibold tw-hidden md:tw-block",
                                                children: shop.name
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "tw-flex tw-gap-10 tw-flex-col",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "tw-flex tw-flex-1",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .JO, {
                                                            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_3__/* .HomeIconActive */ .Pe, {}),
                                                            className: "tw-w-6 tw-h-6 tw-mr-2 tw-text-primary-main "
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "tw-flex-1 tw-flex tw-flex-col lg:tw-flex-row tw-justify-between tw-gap-2 lg:tw-gap-10 lg:tw-items-end",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "tw-flex-1",
                                                                    children: shop.address
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_3__/* .Link */ .rU, {
                                                                    target: "_blank",
                                                                    url: shop.map,
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        className: "tw-underline tw-decoration-solid",
                                                                        children: "Xem bản đồ"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_3__/* .Link */ .rU, {
                                                url: "tel:".concat(shop.phone_url),
                                                className: "tw-flex tw-items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_3__/* .Image */ .Ee, {
                                                        alt: "call",
                                                        src: "/call.svg",
                                                        objectFit: "contain",
                                                        className: "tw-w-6 tw-h-6 tw-mr-2"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "tw-text-secondary-70",
                                                        children: shop.phone
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "tw-flex tw-items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .JO, {
                                                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_3__/* .ClockSolidIcon */ .TI, {}),
                                                        className: "tw-w-6 tw-h-6 tw-mr-2 tw-text-primary-main"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "tw-flex-1",
                                                        children: shop.time
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, shop.name);
                        })
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ShopsPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(16027); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);